import React from 'react';

interface ContextProps {
	logo: any;
	footer: any;
	settings: any;
	blocks_manager: any;
}

export const DataContext = React.createContext<ContextProps>({
	logo: {},
	footer: {},
	settings: {},
	blocks_manager: {},
});

const DataProvider = ({ data, children }) => {
	const defaultContext = data;

	return (
		<DataContext.Provider value={defaultContext}>
			{children}
		</DataContext.Provider>
	);
};

export default DataProvider;
